
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductSpecificationsGrid1 extends Serenity.EntityGrid<ProductSpecificationsRow, any> {
        protected getColumnsKey() { return 'Products.ProductSpecifications' }
        protected getDialogType() { return ProductSpecificationsDialog; }
        protected getIdProperty() { return ProductSpecificationsRow.idProperty; }
        protected getInsertPermission() { return ProductSpecificationsRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductSpecificationsRow.localTextPrefix; }
        protected getService() { return ProductSpecificationsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected addButtonClick() {
            this.editItem({ ProductId: this.ProductId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.ProductId != null;
        }

        private _ProductId: number;

        get ProductId() {
            return this._ProductId;
        }

        set ProductId(value: number) {
            //debugger;
            if (this._ProductId != value) {
                this._ProductId = value;
                this.setEquality(ProductSpecificationsRow.Fields.ProductId, value);
                this.refresh();
            }
        }
    }
}